import React, { useState } from "react";
import classNames from "classnames/bind";
import { useIntl } from "react-intl";
import { Space, Row, Button } from "@masterteam/mt-design-react";

import useIsAr from ".././../../../Hooks/useIsAr";

import { ReactComponent as ArrowIcon } from "../../../../assets/images/down-arrow.svg";

import styles from "./Collapse.module.scss";

const cx = classNames.bind(styles);

function Collapse({ program, content }) {
  const [isAr] = useIsAr();
  const intl = useIntl();
  const [isOpen, setIsOpen] = useState(true);

  return (
    <Space direction="vertical" size="small" className={styles.container}>
      <Row
        align="center"
        justify="between"
        className={cx({ header: true, open: isOpen })}
      >
        <Space size="small">
          <h5>
            {program
              ? isAr
                ? program?.ArabicName
                : program?.EnglishName
              : intl.formatMessage({ id: "common.others" })}
          </h5>
        </Space>

        <Button
          variant="dark"
          shape="circle"
          backgroundColor="white"
          Icon={ArrowIcon}
          onClick={(e) => {
            e.stopPropagation();
            setIsOpen(!isOpen);
          }}
        />
      </Row>

      {isOpen && content}
    </Space>
  );
}

export default Collapse;
